/**
 * Footer Component
 * シンプルで洗練されたフッターデザイン
 */

import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'ホーム', path: '/' },
    { name: '会社について', path: '/about' },
    { name: '事業内容', path: '/business' },
    { name: '採用情報', path: '/recruitment' },
  ];

  return (
    <footer className="bg-gray-50 border-t border-gray-200">
      {/* Main Footer */}
      <div className="container-custom py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {/* Company Info */}
          <div>
            <img
              src="/assets/images/KBSH_RS_logo.png"
              alt="株式会社RS"
              className="h-10 w-auto object-contain mb-4"
            />
            <p className="text-gray-600 text-sm leading-relaxed">
              株式会社RSは通信事業を中心に、お客様の暮らしをより豊かにするサービスを提供しています。
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-gray-900 font-bold mb-4 text-sm">クイックリンク</h3>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-gray-600 hover:text-rs-orange transition-colors duration-300 text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-gray-900 font-bold mb-4 text-sm">採用に関するお問い合わせ</h3>
            <p className="text-gray-600 text-sm mb-4">
              採用に関するご質問は、応募フォームよりお問い合わせください。
            </p>
            <Link
              to="/recruitment"
              className="inline-block text-rs-orange hover:text-rs-orange-dark transition-colors duration-300 text-sm font-medium"
            >
              採用エントリーはこちら →
            </Link>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-200 bg-white">
        <div className="container-custom py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-500 text-sm">
              © {currentYear} 株式会社RS. All rights reserved.
            </p>
            <Link
              to="/privacy"
              className="text-gray-500 hover:text-rs-orange transition-colors duration-300 text-sm"
            >
              プライバシーポリシー
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
